import * as React from 'react'
import { Col, config, Container, Row } from 'react-awesome-styled-grid'
import { NewReleasesRow } from '@components/home/NewReleases/NewReleasesRow'
import { PopularTracksRow } from '@components/home/NewReleases/PopularTracksRow'
import styled from 'styled-components'
import FadeInContent from '@components/shared/FadeInContent'
import HomeEmailCapture from '@components/home/HomeEmailCapture'

export default function NewReleasesAndPopularTracks (_props: {}): React.ReactNode {
  return (
    <FadeInContent fadeInTime={1}>
      <Container>
        <Row>
          <Col>
            <Wrapper>
              <NewReleasesRow />
              <PopularTracksRow />
              <UnlockSection>
                <HomeEmailCapture />
              </UnlockSection>
            </Wrapper>
          </Col>
        </Row>
      </Container>
    </FadeInContent>
  )
}

const UnlockSection = styled.div<any>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 80px 0px 80px 0px;
    width: 100%;
    ${(props: any): any => config(props).media.xs`
  `}
    ${(props: any): any => config(props).media.sm`
  `}
    ${(props: any): any => config(props).media.md`
    padding: 160px 0px 160px 0px;
  `}
    ${(props: any): any => config(props).media.lg`
  `}
    ${(props: any): any => config(props).media.xl`
  `}
`
const Wrapper = styled.div<any>`
  min-height: 50vh;
`
